import { buildQuery, parseQuery } from '@calendly/http-tools'
import { Loader } from '@calendly/ui/components/loader'
import { useRouteMatch } from 'react-router-dom'
import { BodyText } from '@calendly/ui/components/typography'

import ErrorAlert from 'components/error/alert'
import { useGetEventTypesQuery } from 'root-api'

import {
  Arrow,
  Header,
  Link,
  Marker,
  TitleContainer
} from './styles'

const EventType = ({ color, name, description, url }) => (
  <Link href={url} data-id="event-type">
    <Header>
      <Marker color={color} data-id="event-type-marker" />
      <TitleContainer data-id="event-type-header-title">
        <BodyText size="large" weight="bold">
          {name}
        </BodyText>
      </TitleContainer>
      <Arrow data-id="event-type-arrow" />
    </Header>
    <BodyText size="medium" data-id="event-type-description">
      {description}
    </BodyText>
  </Link>
)

export default function EventTypes({ searchString }) {
  const profileSlug = useRouteMatch().params.profileSlug
  const { data: eventTypes, isLoading, isError } = useGetEventTypesQuery({ slug: profileSlug })
  const searchParams = parseQuery(searchString)
  searchParams.back = 1
  const query = buildQuery(searchParams)

  if (isLoading) return <Loader />

  if (isError) {
    return (
      <ErrorAlert
        error={{}}
        buttonClick={() => window.location.reload()}
      />
    )
  }

  return eventTypes.map(({ uuid, slug, color, name, description }) => (
    <EventType
      key={uuid}
      url={`/${profileSlug}/${slug}?${query}`}
      color={color}
      name={name}
      description={description}
    />
  ))
}
